/* eslint-disable  */
import {
  getAuth as firebaseGetAuth,
  setPersistence,
  browserLocalPersistence,
} from "@firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getFunctions } from "@firebase/functions";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseConfigs = {
  development: {
    apiKey: "AIzaSyAwIQQVteiwNs5V5XGOsLnJ_K8Mn7rXRac",
    authDomain: "zawadi-dev.firebaseapp.com",
    projectId: "zawadi-dev",
    storageBucket: "zawadi-dev.appspot.com",
    messagingSenderId: "662521322075",
    appId: "1:662521322075:web:f3d017541549cd07ee7d7e",
    vapidKey:
      "BHDI5xR2me0XUpt39zcGJlrOh1DUEkJqQKHFrWwRRqa8sMJXopSt9m2qUAg4Coc4ehJ-X1b0GRKuhGYgSiVqfUc",
  },
  production: {
    apiKey: "AIzaSyBShinD9EgXinSJ2WdS7Lyd2xtAFjn-_2M",
    authDomain: "zawadi-e2cad.firebaseapp.com",
    projectId: "zawadi-e2cad",
    storageBucket: "zawadi-e2cad.appspot.com",
    messagingSenderId: "18072782301",
    appId: "1:18072782301:web:0d6390c0bc87dcc01f6234",
    vapidKey:
      "BHDI5xR2me0XUpt39zcGJlrOh1DUEkJqQKHFrWwRRqa8sMJXopSt9m2qUAg4Coc4ehJ-X1b0GRKuhGYgSiVqfUc",
  },
};

const currentConfig = firebaseConfigs.production;
const app = initializeApp(currentConfig);

const auth = firebaseGetAuth(app);
setPersistence(auth, browserLocalPersistence);

export { auth };
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const messaging = getMessaging(app);

// FCM token management
export const requestNotificationPermission = async () => {
  try {
    let permission;

    if ("Notification" in window) {
      permission = await Notification.requestPermission();
    } else {
      permission = "denied";
    }

    if (permission === "granted") {
      const currentToken = await getFCMToken();
      return currentToken;
    }

    // Check if we"re on a mobile device
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );

    // On iOS Safari, notifications require https and special handling
    if (isMobile && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      // iOS Safari requires user interaction to request permission
      // We need to ensure this is called from a user interaction event
      if (Notification.permission === "default") {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          console.log("Notification permission not granted on iOS");
          return null;
        }
      } else if (Notification.permission !== "granted") {
        console.log("Notification permission not previously granted on iOS");
        return null;
      }
    } else {
      // Handle normal permission flow for other browsers
      if (Notification.permission === "default") {
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
          console.log("Notification permission not granted");
          return null;
        }
      } else if (Notification.permission !== "granted") {
        console.log("Notification permission not previously granted");
        return null;
      }
    }

    // Get the FCM token after permission is granted
    const token = await getFCMToken();
    return token;
  } catch (error) {
    console.error("Error requesting notification permission:", error);
    return null;
  }
};

export const getFCMToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey:
        process.env.REACT_APP_FIREBASE_VAPID_KEY ||
        firebaseConfigs.production.vapidKey,
    });
    if (currentToken) {
      return currentToken;
    }
    throw new Error("No registration token available");
  } catch (error) {
    // console.error("Error getting FCM token:", error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      resolve(payload);
    });
  });

export default app;
